import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Box } from 'src/components/Box';
import { CircularProgress } from 'src/components/CircularProgress';
import { Typography } from 'src/components/Typography';
import { fetchUser } from 'src/models/user/user';
import { Identifier } from 'src/types/utilityTypes';
import { useListSearchParams } from 'src/utils/useListSearchParams';

export default function FindClientsPage() {
  const { filterParams } = useListSearchParams();
  const navigate = useNavigate();
  const { data } = useQuery({
    queryKey: ['users', filterParams.userId, filterParams.tab],
    queryFn: () => fetchUser({ id: filterParams.userId as Identifier }),
  });

  useEffect(() => {
    if (data) {
      const tab = filterParams.tab || '';
      navigate(`/clients/${data.trainerAssociationId}/${tab}`, {
        replace: true,
      });
    }
  }, [data, filterParams.tab, navigate]);

  const { t } = useTranslation('translation');

  return (
    <Box
      component="main"
      sx={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        minHeight: '90vh',
      }}
    >
      <CircularProgress size="large" />
      <Typography
        align="center"
        sx={{
          color: 'text.secondary',
          mt: 5,
        }}
      >
        {t('Loading')} {t('Client')}
      </Typography>
    </Box>
  );
}
